module.exports = {"BaseUrl":"/api","FullApiUrl":"https://www.lekkerhot.nl","ImageUrl":"//img.lekkerhot.nl/files/","Site":"lekkerhot","GoogleTagCode":"GTM-PGD5M4Q"}


//////////////////
// WEBPACK FOOTER
// ./src/private.production.json
// module id = aydD
// module chunks = 0